import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "../modal";
import get from "lodash/get";
import map from "lodash/map";
import { RillContext } from "../../rill/RillReact/share/base";

class UpdatePaymentModal extends React.Component {
  render() {
    const { t } = this.props;
    const {
      countries: countryOptions,
      activeUser,
      getCountryName,
    } = this.context.locals;
    return (
      <form
        action="/actions/billing/update/source"
        id="form-change-card"
        method="POST"
        data-noreset
      >
        <Modal width="600px">
          <div className="head">
            <h2 className="alt">{t("updatePayment.title")}</h2>
          </div>

          <div className="body">
            <div className="columns">
              <div className="column" data-col="1/1">
                <div className="label">{t("updatePayment.creditCardNumber")}</div>
                <input
                  required
                  type="text"
                  name="source[number]"
                  className="text-input fs-hide"
                  placeholder={t("updatePayment.creditCardPlaceholder")}
                />
              </div>

              <div className="column" data-col="1/4">
                <div className="label">{t("updatePayment.expiry")}</div>
                <input
                  required
                  type="text"
                  name="source[exp]"
                  className="text-input fs-hide"
                  placeholder={t("updatePayment.expiryPlaceholder")}
                />
              </div>

              <div className="column" data-col="1/4">
                <div className="label">{t("updatePayment.securityCode")}</div>
                <input
                  required
                  type="text"
                  name="source[cvc]"
                  className="text-input fs-hide"
                  placeholder={t("updatePayment.cvcPlaceholder")}
                />
              </div>

              <div className="column" data-col="1/1">
                <div className="label">{t("updatePayment.address")}</div>
                <input
                  className="text-input"
                  type="text"
                  name="source[address_line1]"
                  style={{ marginBottom: "20px" }}
                />
              </div>

              <div className="column" data-col="3/4">
                <div className="label">{t("updatePayment.city")}</div>
                <input
                  className="text-input"
                  type="text"
                  name="source[address_city"
                />
              </div>

              <div className="column" data-col="1/4">
                <div className="label">{t("updatePayment.postalCode")}</div>
                <input
                  className="text-input"
                  type="text"
                  name="source[address_zip]"
                />
              </div>

              <div className="column" data-col="1/1">
                <div className="label">{t("updatePayment.country")}</div>
                <select
                  required
                  name="source[address_country]"
                  className="select-input"
                  defaultValue={get(activeUser, "country", "")}
                >
                  <option hidden disabled value="">
                    {t("updatePayment.locationPlaceholder")}
                  </option>
                  {map(countryOptions, (code) => {
                    return (
                      <option key={code} value={code}>
                        {getCountryName(code)}
                      </option>
                    );
                  })}
                </select>
              </div>

              <hr />
            </div>
          </div>

          <div className="foot">
            <div className="columns">
              <div className="column" data-col="1/2">
                <button className="button-input" type="submit">
                  {t("updatePayment.saveChanges")}
                </button>
              </div>

              <div className="column mobile-hidden" data-col="1/2">
                <a className="cancel" href="/actions/refresh?modal=">
                  {t("common:cancel")}
                </a>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

UpdatePaymentModal.contextType = RillContext;

export default withTranslation("coaching-portal")(UpdatePaymentModal);
